import { configuracionEsquema } from './formularios/configuracionEsquemas.model';

export class actualizarConfiguracionesRequest{
    requestAnt:configuracionEsquema;
    requestNu:configuracionEsquema;
}